import React, { useEffect, useState } from 'react'
import arrow from '../../Assests/20382d550b72cbf6f749294cd4e529215741654c.png'
import facebook from '../../Assests/ee50e467241a4a5b1469e6fbe4e1491df7da03c8.png'
import x from '../../Assests/974b66e5853edd33915dc8029fc05fe5be2813ed.png'
import instagram from '../../Assests/f0bd89e1043fabacc3dc40272d80b0bc2bddbf4a.png'
import linkeding from '../../Assests/social.png'
import './Footer.css'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import { urlApiServer } from '../../Config/Config'

function Footer() {

    const navigate = useNavigate(); // Correct hook usage
    const location = useLocation();

    // const urlGetArticles = `${urlApiServer}articles?populate=*`
    const urlGetContactDetail = `${urlApiServer}Company-details?populate=*`


    // const [topic, setTopic] = useState()
    const [dataInformation, setDataInformation] = useState([]);
    const [categorys, setCategorys] = useState([]);
    const [about, setAbout] = useState([]); // Initialize as empty array instead of undefined

    const urlGetCategorys = `${urlApiServer}categorias?populate=*`
    const urlGetAbout = `${urlApiServer}about-uses?populate=*`

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetCategorys, requestOptions)
                    .then(response => response.json())
                    .then(ContactResponse => {
                        console.log('info del Categoria: ', ContactResponse.data);

                        // Asegurar que siempre sea un array
                        if (Array.isArray(ContactResponse.data)) {
                            setCategorys(ContactResponse.data.reverse());
                        } else {
                            setCategorys([]);
                        }
                    });
            } catch (error) {
                console.log('el backend esta temporalmente desactivado');
                setCategorys([]); // Asegurar que sea un array vacío en caso de error
            }
        })();
    }, [urlGetCategorys]);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetAbout, requestOptions)
                    .then(response => response.json())
                    .then(ContactResponse => {
                        console.log('Sobre nosotros footer: ', ContactResponse)
                        setAbout(ContactResponse.data || []); // Fallback to empty array
                    });
            } catch (error) {
                console.log('el backend esta temporalmente desactivado');
                setAbout([]); // Set empty array on error
            }
        })();
    }, [urlGetAbout]);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetContactDetail, requestOptions)
                    .then(response => response.json())
                    .then(ContactResponse => {
                        console.log('info del Contact: ', ContactResponse.data);

                        // Asegurar que siempre sea un array
                        setDataInformation(Array.isArray(ContactResponse.data) ? ContactResponse.data : []);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente desactivado');
                setDataInformation([]); // Asegurar que sea un array vacío en caso de error
            }
        })();
    }, [urlGetContactDetail]);

    const handleCategoryClick = (selectCategory) => {
        // Correct navigation using the hook
        navigate('/Inicio', { state: { category: selectCategory } });
    };


    // ❌ No renderizar el footer en la ruta /Collecciones
    if (location.pathname === '/Collecciones') return null;

    return (
        <div className="footerContainer">
            <div className='optionFooterContainer'>
                <div className='opcionFooter'>
                    <div>
                        <p className='titlesFooter'>REBORN</p>
                    </div>
                    <div className='aboutFooterContainer'>
                        <p className='optionsFooter'>
                            {about.length > 0 ? about[0]?.frase : "Cargando..."}
                        </p>
                        <NavLink to="/Sobre_nosotros" className="activeNav">
                            <div className='readMoreContainer'>
                                <p className='optionsFooter'>
                                    Leer más
                                </p>
                                <img src={arrow} alt='arrow' className='arrowFooter' />
                            </div>
                        </NavLink>
                    </div>
                </div>
                <div className='opcionFooter'>
                    <div>
                        <p className='titlesFooter'>CATEGORIES</p>
                    </div>
                    <div>
                        {Array.isArray(categorys) && categorys.map((item, index) => {
                            return (
                                <p className='optionsFooter optionsCategoryFooter' onClick={() => handleCategoryClick(item)} key={index}>{item.Nombre}</p>
                            )
                        })}
                    </div>
                </div>
                <div className='opcionFooter'>
                    <div>
                        <p className='titlesFooter'>LINKS</p>
                    </div>
                    <div>
                        <NavLink to="/Inicio" className="activeNav">
                            <p className='optionsFooter optionsLinksFooter'>Inicio</p>
                        </NavLink>
                        <NavLink to="/Collecciones" className="activeNav">
                            <p className='optionsFooter optionsLinksFooter'>Colecciones</p>
                        </NavLink>
                        <NavLink to="/Fabrica" className="activeNav">
                            <p className='optionsFooter optionsLinksFooter'>Fabrica</p>
                        </NavLink>
                        <NavLink to="/Sobre_nosotros" className="activeNav">
                            <p className='optionsFooter optionsLinksFooter'>Conocenos</p>
                        </NavLink>
                        <NavLink to="/Contactanos" className="activeNav">
                            <p className='optionsFooter optionsLinksFooter'>Contacto</p>
                        </NavLink>
                    </div>
                </div>
                <div className='opcionFooter'>
                    <div>
                        <p className='titlesFooter'>FOLLOW ME</p>
                    </div>
                    <div className='socialNetworksFooterContainer'>

                        {dataInformation.length > 0 && dataInformation[0]?.x_url && (
                            <a href={dataInformation[0].x_url}>
                                <img src={x} alt='x' className='socialNetworksFooter optionsSocialNetworksFooter' />
                            </a>
                        )}
                        {dataInformation.length > 0 && dataInformation[0]?.instagram_url && (
                            <a href={dataInformation[0].instagram_url}>
                                <img src={instagram} alt='instagram' className='socialNetworksFooter optionsSocialNetworksFooter' />
                            </a>
                        )}
                        {dataInformation.length > 0 && dataInformation[0]?.Facebook_url && (
                            <a href={dataInformation[0].Facebook_url}>
                                <img src={facebook} alt='facebook' className='socialNetworksFooter optionsSocialNetworksFooter' />
                            </a>
                        )}
                        {dataInformation.length > 0 && dataInformation[0]?.linkeding_url && (
                            <a href={dataInformation[0].linkeding_url}>
                                <img src={linkeding} alt='linkeding' className='socialNetworksFooter optionsSocialNetworksFooter' />
                            </a>
                        )}
                    </div>
                </div>
            </div>
            <div>
                <p className='copyrightFooter'>2025 RebornPty.  All rights reserved.</p>
                <p className='copyrightFooter'>Developed by Genios Tecnologicos</p>
            </div>
        </div>

    )
}

export default Footer
